export const hintCopy = {
  US: {
    bankRoutingNumber: {
      title: 'Routing number (ABA)',
      description:
        'This nine-digit figure is the first set of numbers on the bottom of the check.'
    },
    accountNumber: {
      title: 'Account number',
      description: 'Second set of number on the check. Typically 9-10 digits.'
    },
    checkNumber: {
      title: 'Check number',
      description: 'Third number on the bottom set. Typically 3-4 digits. '
    },
    nombreOnCheck: {
      title: 'Name on check',
      description: 'Name on top left corner of the check',
      hintPosition: 'right'
    }
  },
  canada: {
    nombreOnCheck: {
      title: 'Name on check',
      description: 'Name on top left corner of the check',
      hintPosition: 'right'
    },
    checkNumber: {
      title: 'Check number',
      description: 'First set of numbers on the bottom set. Typically 3-4 digits. '
    },
    branchNumber: {
      title: 'Branch number',
      description: 'This five-digit figure is second set of numbers on the check.'
    },
    institutionNumber: {
      title: 'Institution number',
      description: 'Third set on the bottom of check. 3 digits.'
    },
    accountNumber: {
      title: 'Account number',
      description:
        'Last set of numbers on the bottom. Typically 7 digits. Depending on the check, there might be a 4-digit number before this, ignore that.'
    }
  }
}
